import { removeAccents } from "@/helpers/CommonHelper";

export const getPalletImage = (
    featureValues : Array<{
        id: string;
        featureId: string;
        featureName: string;
        featureValues: string[];
    }>

) : string =>  {

    let material = featureValues.find(fv => fv.featureName.toLowerCase() == 'material')?.featureValues[0];
    const tmpColor = featureValues.find(fv => fv.featureName.toLowerCase() == 'color')?.featureValues;
    let color = "";
    if(tmpColor != undefined && tmpColor.length > 0) {
        color = tmpColor[0];
    }

    if(material == undefined) {
        material = "MADERA";
    }



    const image = mapImages(material.toString(), color?.toString())
    return image;

}


export const mapImages = (material: string, color?:string) : string => {
    switch (removeAccents(material).toUpperCase()) {
        case 'MADERA':
            if(color){
                return mapColor(color);
            }
            else{
                return require('@/assets/images/default_images/Pallet_wood_light.png');
            }
        case 'WOOD':
            if(color){
                return mapColor(color);
            }
            else{
                return require('@/assets/images/default_images/Pallet_wood_light.png');
            }
        case 'PLASTIC':
            return require('@/assets/images/default_images/Pallet_plastic.png');
        case 'PLASTICO':
            return require('@/assets/images/default_images/Pallet_plastic.png');
        case 'CARDBOARD':
            return require('@/assets/images/default_images/Pallet_cardboard.png');
        case 'CARTON ONDULADO':
            return require('@/assets/images/default_images/Pallet_cardboard.png');
        case 'METAL':
            return require('@/assets/images/default_images/Pallet_metal.png');
        default:
            return require('@/assets/images/default_images/No-foto.png');
    }
}

const mapColor = (color:string):string=>{
    switch (color.toUpperCase()){
        case 'AZUL':
            return require('@/assets/images/default_images/Pallet_wood_blue.png');
        case 'GRANATE':
            return require('@/assets/images/default_images/Pallet_wood_purple.png');
        case 'ROJO':
            return require('@/assets/images/default_images/Pallet_wood_red.png');
        case 'AMARILLO':
            return require('@/assets/images/default_images/Pallet_wood_yellow.png');
        case 'SIN PINTAR':
            return require('@/assets/images/default_images/Pallet_wood_light.png');
        default:
            return require('@/assets/images/default_images/Pallet_wood_light.png');
    }
}
  